import herdInstinct from "./components/product/herd_instinct";
import initSimilarProducts from "./screens/product/similar_products";
import initTooltips from "./components/tooltips";
import './components/recaptcha';
import { initPhotoPopups } from "./components/photoswipe";
import { initProductOfferApp, initSetCardApp } from "./screens/product/card";
import { makeProductSlider, makeProductThumbsSlider, makeSimilarProductsCarousel, makeTagsSlider } from "./components/slider";
import initPerfumeCharts from "./components/perfume_charts";
document.addEventListener('DOMContentLoaded', function () {
    initTooltips();
    document.querySelector('.click_now')?.click();
});
const thumbsSlider = makeProductThumbsSlider();
const productSlider = makeProductSlider(thumbsSlider);
productSlider.on('slideChange', () => thumbsSlider.slideTo(productSlider.realIndex - 1));
initProductOfferApp(productSlider, thumbsSlider);
initSetCardApp();
initSimilarProducts();
makeTagsSlider();
makeSimilarProductsCarousel();
initPhotoPopups();
herdInstinct(document.querySelector('.prod-msg'));
initPerfumeCharts();
